// Japanese translations
export const japaneseTranslations = {
  header: {
    title: "パートナーシップと協力のページ",
    subtitle: "信頼性。革新性。協調性。",
    breadcrumb: {
      home: "ホーム",
      current: "パートナーシップと協力のページ"
    }
  },
  introduction: {
    paragraph1: "1998年に設立された Business Automation Limited は、バングラデシュ初のIT対応サービス（ITES）プロバイダーの一つとして誕生し、「地域のニーズに合わせた世界水準のデジタルソリューションで組織を強化する」という大胆なビジョンを掲げてきました。27年以上にわたり、私たちは 電子政府（eGovernment）分野の革新企業 として信頼を築き、バングラデシュ国内外で 300以上の公共および民間クライアント にサービスを提供しています。",
    paragraph2: "当社のソリューションは、エンタープライズソフトウェアや市民サービスポータルから、IoT対応システムやワークフロー自動化 に至るまで、サービス提供の質を高め、業務効率を向上させ、包括的なデジタル成長を促進しています。 本社はバングラデシュのダッカにあり、自社の研究開発、最新のUI/UXラボ、そして強固なアフターケア体制 を通じて、エンドツーエンドのプラットフォームを提供しています。 女性や若手専門家を中心とする当社の学際的チームは、スマートキオスク、顧客サービス管理ツール、そして何百万人もの人々に利用される国家規模の自動化プラットフォーム など、社会的に大きな影響を与えるシステムを開発してきました。",
    paragraph3: "当社は ISO 9001、ISO 20000、ISO 27000 の認証を取得した組織として、地域の中小企業から国家規模のデジタルトランスフォーメーション事業に至るまで、すべてのプロジェクトにおいて卓越性を追求しています。また、メンターシップ制度、柔軟な勤務時間、AI／RPAトレーニング を通じて、女性や若手専門家が活躍できる包括的な職場環境を整えています。このようにして、当社は バングラデシュの多様な人材を反映するチーム を育成し、持続的な成長と革新を実現しています。",
    paragraph4: "政府機関の支援であれ、国際機関との協業であれ、Business Automation は、課題をチャンスに変えるための 最適な人材・ツール・ビジョン を提供します。",
  },
  howWeCanHelp: {
    title: "私たちがお手伝いできること：",
    subtitle: "バングラデシュにおけるローカルパートナーとして当社を選んでいただくことで、次のようなサポートを受けられます。",
    services: [
      {
        title: "現地サポート: ",
        description: "時差、文化の違い、言語の壁といった要因は、国際ビジネスを困難にします。そこで当社は、バングラデシュでのプロジェクトを現地でサポート することで、こうした課題を解消し、スムーズな事業運営を実現します。"
      },
      {
        title: "全国規模の展開:",
        description: "当社は首都だけでなく、都市部や地方を問わず バングラデシュ全国でのプロジェクト実行 を確実に行うことができます。"
      },
      {
        title: "バングラデシュの法規およびガバナンスに基づく業務遂行能力:",
        description: "国際ビジネスにおいて、法規や規制の遵守は非常に重要です。当社はこれらの分野における専門知識を活かし、手続きを効率化し、処理時間を短縮 することができます。"
      },
      {
        title: "実績ある専門知識: ",
        description: "当社は グローバルソリューションを現地の技術、ユーザーインターフェース、インフラストラクチャとシームレスに統合 し、グローバルシステムとローカルシステムの間で円滑な連携と接続を実現します。"
      },
      {
        title: "データ入力、マッピング、スケーラブルソリューション:",
        description: "当社は、正確なデータ入力・処理、地理マッピング、エリア作成、地図プラットフォーム統合サービス を提供するとともに、事業成長に対応可能なスケーラブルなITインフラ を整えています。"
      },
      {
        title: "保守・運用サポート:",
        description: "当社は、事前モニタリング、迅速な問題解決、包括的な年間保守契約（AMC）、多言語対応の24時間365日技術ヘルプデスク を提供し、システムのダウンタイムを最小限に抑えます。例えば、BCIC、BIDA、A2i、RAJUK、JICA などに対しても継続的な技術サポートを提供しています。"
      },
      {
        title: "トレーニングと能力開発: ",
        description: "当社は、製品の導入促進や現地チーム・ディストリビューターの成功を支援するための、対面およびオンライン形式の体系的なトレーニングプログラム を実施しています。例えば、JICA、RAJUK、A2i、BIDA、UNDP、世界銀行、BEPRC、BTRC、BHTPA、BCSIR、BASIS のプロジェクトに対してワークショップを提供した実績があります。"
      },
      {
        title: "包括的な文化:",
        description: "当社の 100名以上のチーム は、そのうち 25％が女性および若手専門家 で構成されており、多様性を通じてイノベーション を推進しています。"
      }
    ]
  },
  // trustedPartner: {
  //   title: "私たちが信頼できるパートナーである理由",
  //   subtitle: "簡単に言えば、あなたのニーズが私たちの優先事項であり、基本的な一律のソリューションを超えています。私たちと一緒に、あなたは特にあなたのために機能する技術ソリューションを受け取ることができます。さらに、私たちは以下を持っています：",
  //   trackRecordTitle: "私たちの実績がすべてを物語っています：",
  //   stats: [
  //     {
  //       number: "27年以上",
  //       title: "約30年の歴史を持つバングラデシュの主要なITES企業。"
  //     },
  //     {
  //       number: "300以上",
  //       title: "30以上の省庁を含む300以上の公共部門エンティティに信頼されています"
  //     },
  //     {
  //       number: "10以上",
  //       title: "10以上の国家/地方e-Govプラットフォームへの関与"
  //     }
  //   ],
  //   trackRecord: [
  //     {
  //       text: "サービスとプロセスの簡素化のためのお客様との関わり。"
  //     },
  //     {
  //       text: "バングラデシュで最大級の第三者統合の一つの経験",
  //       linkText: "（詳細を見る）"
  //     },
  //     {
  //       text: "さまざまな政府機関での公共データ分析の成功実装記録。（SDG追跡、A2iダッシュボード、エネルギー管理、公共サービス管理など）"
  //     },
  //     {
  //       text: "国家データセンターと4層データセンターを含む、さまざまなデータセンターでホストされているサーバーの管理とdevOpsサービスの提供。",
  //       linkText: "（詳細を見る）"
  //     },
  //     {
  //       text: "大規模データとデータ移行の管理経験（2100万件以上のレコード、データサイズ175TB以上の最大経験）"
  //     },
  //     {
  //       text: "私たちのトレーニングプラットフォームを使用した全国的なトレーニングサービス提供の経験。"
  //     },
  //     {
  //       text: "成功したプロジェクト展開のためのレコードデジタル化（データ入力、文書と地図のスキャンなど）の経験。",
  //       linkText: "（詳細を見る）"
  //     },
  //     {
  //       text: "当社のカスタマーサービスプラットフォームを通じて、プロジェクトの要求に応じて技術サポートサービスを提供した経験",
  //       linkText: "（詳細を見る）"
  //     }
  //   ]
  // },
  // trackRecord: {
  //   title: "私たちの実績",
  //   subtitle: "デジタルソリューション提供における実証された優秀性",
  //   items: [
  //     {
  //       icon: "/png/pc_1.png",
  //       alt: "エンゲージメント",
  //       text: "サービスとプロセスの簡素化のためのお客様とのエンゲージメント。",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_2.png",
  //       alt: "API統合",
  //       text: "バングラデシュで最大規模のサードパーティ統合の経験の一つ",
  //       hasLink: true,
  //       linkText: "（詳細を見る）",
  //       linkUrl: "/services/api-integration",
  //     },
  //     {
  //       icon: "/png/pc_3.png",
  //       alt: "分析",
  //       text: "異なる政府機関における公共データ分析の成功実装記録（SDG追跡、A2iダッシュボード、エネルギー管理、公共サービス管理など）",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_4.png",
  //       alt: "サーバー管理",
  //       text: "国家データセンターや4階層データセンターを含む異なるデータセンターでホストされているサーバーの管理とDevOpsサービスの提供。",
  //       hasLink: true,
  //       linkText: "（詳細を見る）",
  //       linkUrl: "/services/devops-services",
  //     },
  //     {
  //       icon: "/png/pc_5.png",
  //       alt: "データ管理",
  //       text: "大規模データとデータ移行の管理経験（2100万+レコード、データサイズ175+ TBの最大経験）",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_6.png",
  //       alt: "トレーニング",
  //       text: "私たちのトレーニングプラットフォームを使用した全国的なトレーニングサービス提供の経験。",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_7.png",
  //       alt: "デジタル化",
  //       text: "成功したプロジェクト展開のためのレコードデジタル化（データ入力、文書と地図のスキャンなど）の経験。",
  //       hasLink: true,
  //       linkText: "（詳細を見る）",
  //       linkUrl: "/services/record-digitization-services",
  //     },
  //     {
  //       icon: "/png/pc_8.png",
  //       alt: "サポート",
  //       text: "当社のカスタマーサービスプラットフォームを通じて、プロジェクトの要求に応じて技術サポートサービスを提供した経験",
  //       hasLink: true,
  //       linkText: "（詳細を見る）",
  //       linkUrl: "/services/tech-support-services",
  //     },
  //   ],
  // },
  // collaboration: {
  //   title: "私たちがあなたと協力する方法",
  //   subtitle: "ダイナミックで多様なビジネス環境では、手元のプロジェクトのニーズに応じて異なる形のパートナーシップが必要です。私たちは以下のような潜在的な協力モードのオプションを提供することでそれに適応します：",
  //   modes: [
  //     {
  //       title: "技術配信パートナー",
  //       description: "コンサルタントやプロジェクトに完全な専門知識とシームレスな統合を提供します。"
  //     },
  //     {
  //       title: "共同提案",
  //       description: "G2Pから健康・教育プラットフォームまで、政府RFPの勝利提案を共同作成します。"
  //     },
  //     {
  //       title: "技術ライセンシング",
  //       description: "あなたのイニシアチブのために私たちのプラットフォームをライセンスし、スケールします。"
  //     },
  //     {
  //       title: "アウトソースチーム",
  //       description: "期限付きの任務のための専用開発またはサポートを提供します。"
  //     },
  //     {
  //       title: "フレームワーク協定",
  //       description: "長期国家展開や数年後のL&Tとのスキルオフ割り当てをサポートします。"
  //     }
  //   ],
  //   conclusion: "私たちは常に、バングラデシュの私たちの本拠地であろうとグローバルな環境であろうと、さまざまなセクターの潜在的なクライアントとのパートナーシップを奨励してきました。そのため、新しい時代に向かう中で、信頼できる専門家チームを通じて世界中でより高品質でカスタマイズされた技術ソリューションを提供することを楽しみにしています。"
  // },
  contact: {
    inquiryText: "詳細については、こちらからお問い合わせください",
    buttonText: "お問い合わせ",
    hashtags: "#ビジネスオートメーション #バングラデシュIT企業 #デジタルトランスフォーメーション #グローバルパートナーシップ #eガバメント #IoTソリューション #ワークフロー自動化 #国際ビジネス支援 #女性エンパワーメント #ISO認証企業"
  },
  feedback: {
    question: "この情報はお役に立ちましたか？",
    yes: "はい",
    no: "いいえ",
    thankYou: "フィードバックをありがとうございます！",
    modalTitle: "残念に思います。改善点をお聞かせください。",
    placeholder: "テキストボックス - 最大250文字",
    submit: "送信"
  }
};